module.exports = __webpack_public_path__ + "static/media/down-arrow-white.0a889d7c.svg";